import axios from 'axios';
import { api } from "./api";
import router from './../router';

export const actions = {
  putproduct:({commit},payload)=>{

    return api.setproduct(payload).then(response => {
       // commit('setuserproducts', response.data.oglasi)
          var formData = new FormData();
          formData.append('proid',response.data.proid);
          for (var i = 0; i < payload[1].length; i++) {
              if(payload[1][i]){
              formData.append('images[]',payload[1][i]);
            }
              }
          axios.put(process.env.API_PATH+"/productimg" ,
          formData ,
            {headers: {
          'Content-Type' : 'multipart/form-data'
        }}).then(response=>{
        })

      return Promise.resolve('error')
     }).catch(response => {
       Promise.resolve('error')
     })
  },
  geteditpro:({commit},payload)=>{
      return api.editpro(payload).then(response=>{
            commit('seteditpro', response.data);
      })
  },
  updateproduct:({commit},payload)=>{
      return api.updateproduct(payload).then(response=>{
        if(response.data.insert == 'ok'){
          commit('setedit', false);
        }else {
          alert('Greska prilikom izmene, Molimo Vas ponovite izmenu')
        }
      })
  },
  getproizvodi:({commit},payload)=>{
      return api.proizvodi().then(response=>{
            commit('setkategorije', response.data.kat);
            commit('setpodkategorije', response.data.pod);
      })
  },
  getpro:({commit},payload)=>{
      return api.pro(payload).then(response=>{
            commit('setpro', response.data.pro);

      })
  },
  getallpro:({commit},payload)=>{
      return api.allpro(payload).then(response=>{
              commit('setallpro', response.data.allpro);
              commit('setallpak', response.data.pak);
      })
  },
  getallpodkat:({commit},payload)=>{
      return api.podkat(payload).then(response=>{
              commit('setpodkategorije', response.data.pod);
      })
  },
  getsinglpk:({commit},payload)=>{
    return api.singlpk(payload).then(response=>{
        commit('setsinglpk', response.data.pro);
        commit('setpak', response.data.pak);
    })
  },
  insertpak:({commit},payload)=>{
     api.insertpak(payload).then(response=>{
        if(response.data.insert == 'ok'){
          alert('uspesno ste dodali pakovanje')
          return api.allpro(payload[4]).then(response=>{
                  commit('setallpro', response.data.allpro);
                  commit('setallpak', response.data.pak);
          })
        }
    })
  },
  deletepak:({commit},payload)=>{
     api.deletepak(payload[0]).then(response=>{
        if(response.data.delete == 'ok'){
          alert('uspesno ste obrisali pakovanje')
          return api.allpro(payload[1]).then(response=>{
                  commit('setallpro', response.data.allpro);
                  commit('setallpak', response.data.pak);
          })
        }
    })
  },
  deletepro:({commit},payload)=>{
     api.deletepro(payload[0]).then(response=>{
        if(response.data.delete == 'ok'){
          alert('uspesno ste obrisali proizvod')
          return api.allpro(payload[1]).then(response=>{
                  commit('setallpro', response.data.allpro);
                  commit('setallpak', response.data.pak);
          })
        }
    })
  },
  getpak:({commit},payload)=>{
    return api.pak().then(response=>{
        commit('setpak', response.data.pak);
    })
  },
  getbrand:({commit},payload)=>{
      return api.brand().then(response=>{
            commit('setbrand', response.data.brand);
      })
  },

  getpropics:({commit},payload)=>{
      return api.images(payload).then(response=>{
            commit('setpropics', response.data.propics);
      })
  },
  getkurs:({commit},payload)=>{
      return api.kurs(payload).then(response=>{
            commit('setkurs', response.data.kurs);
      })
  },
  saveti:({commit},payload)=>{
      return api.saveti().then(response=>{
            commit('setsaveti', response.data.saveti);
      })
  },
  savet:({commit},payload)=>{
      return api.savet(payload).then(response=>{
            commit('setsavet', response.data.savet);
            commit('setsliketest', response.data.slikesavet);
      })
  },
  testiranja:({commit},payload)=>{
      return api.testiranja().then(response=>{
            commit('settestiranja', response.data.testiranja);
      })
  },
  test:({commit},payload)=>{
      return api.test(payload).then(response=>{
            commit('settest', response.data.test);
            commit('setsliketest', response.data.sliketest);
            console.log(response.data.slike);
      })
  },
//   contacteng:({commit},payload)=>{
//       return api.contacteng(payload).then(response=>{
//       })
//   },
//   news:({commit},payload)=>{
//     console.log(payload);
//       return api.putnews(payload).then(response=>{
//           if(response.data.mail);
//           alert('invalid email');
//       })
//   },
  orders:({commit},payload)=>{
      return api.naruci(payload).then(response=>{
        // response.data.odgovor
        commit('setporuceno', response.data.odgovor);
      })
  },
//   orderseng:({commit},payload)=>{
//     console.log(payload);
//       return api.ordereng(payload).then(response=>{
//
//       })
//   },
//   logout:({commit},payload)=>{
//       return axios.post(process.env.API_PATH+"/logout").then(response => {
//          commit('setlogin', false)
//          return Promise.resolve('error')
//        }).catch(response => {
//          commit('setlogin', response.data)
//          Promise.resolve('error')
//        })
//     },
//     signin:({commit},payload)=>{
//       return axios.post(process.env.API_PATH+"/login",{
//         email:payload.email,
//         password:payload.password
//       }).then(response => {
//
//           commit('signin', response.data)
//
//         })
//     },
//     login:({commit},payload)=>{
//       return axios.post(process.env.API_PATH+"/isloged",{
//         sid:payload}).then(response => {
//         if(response.data.session == 'ok'){
//           commit('setlogin', true)
//         }else {
//           commit('setlogin', false)
//         }
//          return Promise.resolve('error')
//        }).catch(response => {
//          commit('setlogin', false)
//          Promise.resolve('error')
//        })
//     },
// checksession:({commit},payload)=>{
//   return api.checksession(payload).then(response=>{
//     if(response.data.session=='ok'){
//         // if(window.location.href = 'http://www.beautycore.co.uk/'){
//         //   router.push("/home")
//         // }
//         // if(window.location.href = 'http://www.beautycore.rs/'){
//         //   router.push("/pocetna")
//         // }
//     }else{
//       router.push("/")
//     }
//   })
// },
// getsearch:({commit},payload)=>{
//   return api.fetchsearch(payload).then(response=>{
//     if(response.data.search ==''){
//       commit('setproducts', response.data.search)
//       commit('seterror', true)
//     }else{
//       commit('setproducts', response.data.search)
//       var errors=false
//       commit('seterror', errors)
//
//     }
//
//   })
// },
// getcategories:({commit},payload)=>{
//   return api.fetchcategories().then(response=>{
//       if (response.data.cat == null){
//         var errors = 'There is no categories';
//         commit('seterror', errors)
//       }else{
//       commit('setcategories', response.data.cat)
//
//       var errors = '';
//       commit('seterror', errors)
//       return Promise.resolve('error')
//     }
//     })
// },
// getconcern:({commit},payload)=>{
//   return api.fetchconcern().then(response=>{
//       if (response.data.con == null){
//         var errors = 'There is no categories';
//         commit('seterror', errors)
//       }else{
//       commit('setconcern', response.data.con)
//       var errors = '';
//       commit('seterror', errors)
//       return Promise.resolve('error')
//     }
//     })
// },
// getml:({commit},payload)=>{
//   return api.fetchml().then(response=>{
//       if (response.data.ml == null){
//         var errors = 'There is no packs';
//       }else{
//       commit('setml', response.data.ml)
//       return Promise.resolve('error')
//     }
//     })
// },
// getproducts:({commit},payload)=>{
//   return api.fetchproducts().then(response=>{
//       if (response.data.product == null){
//         var errors = true;
//         commit('seterror', errors)
//       }else{
//       commit('setproducts', response.data.product)
//       return Promise.resolve('error')
//     }
//     })
// },
// getpro:({commit},payload)=>{
//   return api.fetchpro().then(response=>{
//       if (response.data.product == null){
//         var errors = 'There is no products';
//         commit('seterror', errors)
//       }else{
//       commit('setproducts', response.data.product)
//       return Promise.resolve('error')
//     }
//     })
// },
// getproduct:({commit},payload)=>{
//   return api.fetchproduct(payload).then(response=>{
//       if (response.data.singl == null){
//         var errors = 'There is no products';
//         commit('seterror', errors)
//       }else{
//       commit('setsingl', response.data.singl[0])
//       commit('setsinglpro', response.data.singl)
//       commit('setpreporuka', response.data.preporuka)
//       return Promise.resolve('error')
//     }
//     })
// },
// getproductforcart:({commit},payload)=>{
//   return api.fetchproduct(payload).then(response=>{
//       if (response.data.singl == null){
//         var errors = 'There is no products';
//         commit('seterror', errors)
//       }else{
//
//       commit('changecart', response.data.singl[0])
//       return Promise.resolve('error')
//     }
//     })
// },
// putproduct:({commit},payload)=>{
//   return api.putproduct(payload).then(response=>{
//     console.log(response.data);
//     })
// },
// putimg:({commit},payload)=>{
//   return api.putimg(payload).then(response=>{
//     console.log(response.data);
//
//     })
// },

}



// WEBPACK FOOTER //
// ./src/vuex/actions.js